<template src="./TarjetasNuevasMomento.html"></template>

<script>
import {
  actualizarFormulario,
  eliminarFormulariosExistentes
} from "../../apiService/request/crudFormulario";
import DatePicker from "../DatePicker/DatePicker";

export default {
  data() {
    return {
      cantidaElementosMostrar: 0,
      arrayNumeros: [],
      variablesActualizadas: [],
      campoIngresado: null,
      nombreCampo: null,
      padding: "2% 3% 2% 3%",
      gridTemplate: "1fr 1fr 1fr",
      valid: false,
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      menu: false,
      valorVariable: 0,
      options: {
        locale: "es",
        format: "YYYY/MM/DD",
        clearable: true
      }
    };
  },
  props: {
    texto_introductorio: {
      type: String,
      default: null
    },
    borrable: {
      type: Boolean,
      default: false
    },
    nombreFormulario: null,
    idFormulario: null,
    variablesFormulario: null,
    coleccion: null,
    banderaSeguimiento: {
      type: Boolean,
      default: false
    },
    deshabilitado: {
      type: Boolean,
      default: false
    },
    verCompleto: {
      type: Boolean,
      default: false
    },
    banderaTarjetaMiniaturaExpandible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Se actualizan algunos valores del data a sus valores por defecto
     */
    limpiarData() {
      this.variablesActualizadas = [];
      this.campoIngresado = null;
      this.nombreCampo = null;
    },
    /**
     * Se actualiza el formulario (PUT que carga los valores en el back-end)
     */
    async actualizarFormularioActual() {
      if (this.variablesActualizadas.length > 0) {
        try {
          this.$store.dispatch("setCargando", true);
          const respuesta = await actualizarFormulario(
            this.idFormulario,
            this.nombreFormulario,
            this.variablesActualizadas,
            this.coleccion
          );
          this.$store.dispatch("cambiarEstadoModal", true);
          this.$store.dispatch("cambiarMensajeModal", respuesta);
        } finally {
          this.limpiarData();
          this.$emit("limpiarData");
        }
      }
    },
    /**
     * Se genera el JSON para hacer la consulta de actualización de formulario
     * teniendo en cuenta que se debe dar formato a los valores númeriocos
     */
    async actualizarVariables() {
      const arrayActualizar = [];
      if (this.$refs.form.validate()) {
        this.variablesFormulario.map(variable => {
          if (variable.valor != null) {
            arrayActualizar.push({
              nombre: variable.variable,
              valor:
                variable.tipo == "numero"
                  ? Number(variable.valor)
                  : variable.valor
            });
          }
        });
        this.variablesActualizadas = arrayActualizar;
        await this.actualizarFormularioActual();
      }
    },
    /**
     * Se hace la consulta para eliminar un Formulario (DELETE al back-end)
     */
    async eliminarFormulario() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await eliminarFormulariosExistentes(
          this.idFormulario
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } finally {
        this.limpiarData();
        this.$emit("limpiarData");
      }
    },
    calcularNumeros(valor) {
      for (let i = 0; i <= valor; i++) {
        this.arrayNumeros.push(i.toString());
      }
    },
    calcularCantidadSeleccionada(arrayValores) {
      let maximaLongitud = 0;
      arrayValores.map(variable => {
        if (variable.length >= maximaLongitud) {
          maximaLongitud = variable.length;
          if (maximaLongitud >= 7) {
            this.cantidaElementosMostrar = 0;
          } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
            this.cantidaElementosMostrar = 1;
          } else {
            this.cantidaElementosMostrar = 2;
          }
        }
      });
      return arrayValores;
    }
  },
  computed: {
    c_variablesFormulario() {
      let m_variablesFormularios = null;
      m_variablesFormularios = this.variablesFormulario;
      const self = this;
      if (m_variablesFormularios != null) {
        m_variablesFormularios.map(variable => {
          if (variable.nombre.length >= self.valorVariable) {
            self.valorVariable = variable.nombre.length;
            if (self.valorVariable >= 22 && self.valorVariable <= 30) {
              self.gridTemplate = "1fr 1fr";
            } else if (self.valorVariable > 30) {
              self.gridTemplate = "1fr";
            } else {
              self.gridTemplate = "1fr 1fr 1fr";
            }
          }
          if (self.verCompleto === true) {
            self.gridTemplate = "1fr 1fr 1fr";
          }
        });
      }
      return m_variablesFormularios;
    }
  },
  components: {
    DatePicker
  }
};
</script>

<style lang="scss" src="./TarjetasNuevasMomento.scss" scoped></style>
